import React from 'react';
import { Container } from 'react-bootstrap/lib/Tab';

export type IRentTruckTabProps = {

}

const RentTruckTab: React.FC<IRentTruckTabProps> = ({ }) => {
    return (
        <div>

        </div>
    );
}

export { RentTruckTab }